module.exports = __webpack_public_path__ + "media/application/assets/images/spot1-adde590053971e2a7cd564facacaebdc.jpg";